<template>
  <div>
    <div class="gmsqDialog">
      <div class="formmes">
        <el-form ref="form" :model="form" :rules="rules">
          <div class="imgtitle1" style="position: relative">
            <div
              v-preventReClick
              style="
                position: absolute;
                right: 30px;
                top: 30px;
                font-size: 30px;
                color: #606266;
                cursor: pointer;
              "
              @click="back"
            >
              <i class="el-icon-circle-close" />
            </div>
            <img src="@/assets/img/tjhxpxx.png" alt="">
          </div>
          <div class="firstbf">
            <el-form-item label="化学品:" prop="hxpBm" :rules="validateNullLog">
              <el-cascader
                ref="hxps"
                v-model="form.hxpBm"
                placeholder="请选择化学品"
                :disabled="tjhctype"
                :options="options"
                @change="handleChange"
              />
            </el-form-item>
            <el-form-item label="调剂数量:" class="is-required">
              <el-col
                :span="16"
              ><el-form-item
                prop="tjsl"
                :rules="{
                  validator: (rule, value, callback) => {
                    validateSljy(rule, value, callback, 10, 3, 'bt');
                  },
                  trigger: ['blur', 'change'],
                }"
              >
                <el-input
                  v-model="form.tjsl"
                  type="number"
                  :disabled="tjhctype"
                  placeholder="请输入购买数量"
                /> </el-form-item></el-col>
              <el-col :span="8">
                <el-form-item prop="tjslDw" :rules="validateNullLog">
                  <el-select
                    v-model="form.tjslDw"
                    placeholder="请选择单位"
                    :disabled="tjhctype"
                  >
                    <el-option
                      v-for="item in yzd_nsjsl_dw"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select> </el-form-item></el-col>
            </el-form-item>
            <el-form-item label="单价:">
              <el-col
                :span="16"
              ><el-form-item
                prop="dj"
                :rules="{
                  validator: (rule, value, callback) => {
                    if (!/^(0|[1-9][0-9]*)(\.\d+)?$/.test(value)) {
                      return callback('请输入大于或等于0的数量值');
                    } else if (
                      /^[1-9]\d{0,6}(\.\d{1,2})?$|^0(\.\d{1,2})?$/.test(
                        value
                      ) == false
                    ) {
                      return callback('整数位最大长度7位,保留2位小数');
                    }
                    callback();
                  },
                  trigger: ['blur', 'change'],
                }"
              >
                <el-input
                  v-model="form.dj"
                  type="number"
                  :disabled="tjhctype"
                  placeholder="请输入单价"
                /></el-form-item></el-col>
              <el-col :span="8">
                <el-form-item prop="djDw">
                  <el-select
                    v-model="form.djDw"
                    placeholder="请选择单位"
                    :disabled="tjhctype"
                    @change="djDwChange"
                  >
                    <el-option
                      v-for="item in yzd_zjzj"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    /> </el-select></el-form-item></el-col>
            </el-form-item>
            <el-form-item label="总价:">
              <el-col
                :span="16"
              ><el-form-item prop="zj">
                <el-input
                  v-model="form.zj"
                  type="number"
                  disabled
                  placeholder="请输入总价"
                /></el-form-item></el-col>
              <el-col :span="8">
                <el-form-item prop="zjDw">
                  <el-select
                    v-model="form.zjDw"
                    placeholder="请选择单位"
                    disabled
                  >
                    <el-option
                      v-for="item in yzd_zjzj"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    /> </el-select></el-form-item></el-col>
            </el-form-item>
            <el-form-item label="年需求量:" class="is-required">
              <el-col
                :span="16"
              ><el-form-item prop="nxql" :rules="validateNullLog">
                <el-input
                  v-model="form.nxql"
                  disabled
                  placeholder="请输入年需求量"
                /></el-form-item></el-col>
              <el-col :span="8">
                <el-form-item prop="nxqlDw" :rules="validateNullLog">
                  <el-select
                    v-model="form.nxqlDw"
                    placeholder="请选择单位"
                    disabled
                  >
                    <el-option
                      v-for="item in yzd_nsjsl_dw"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    /> </el-select></el-form-item></el-col>
            </el-form-item>
            <el-form-item
              label="用途:"
              prop="yt"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 255);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="form.yt"
                :disabled="tjhctype"
                placeholder="请输入用途"
              />
            </el-form-item>
            <el-form-item
              label="购销合同号:"
              prop="gxhth"
              :rules="{
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'xt', 100);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="form.gxhth"
                :disabled="tjhctype"
                placeholder="请输入购销合同号"
                @input="gxhthImage"
              />
            </el-form-item>
            <el-form-item
              :label="leixing == 'view' ? '核准次数:' : '有效次数:'"
              prop="yxcs"
              class="is-required"
            >
              <el-checkbox-group
                v-model="yxcslist"
                :disabled="tjhctype || yxcsdisabled"
                @change="yxcschange"
              >
                <el-checkbox label="1" name="yxcs">一次有效</el-checkbox>
                <el-checkbox label="2" name="yxcs">多次有效</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item
              label="经办人姓名:"
              prop="jbrZj"
              :rules="validateNullLog"
            >
              <el-select
                v-model="form.jbrZj"
                filterable
                :disabled="tjhctype"
                placeholder="请输入经办人姓名"
                @change="jbrChange"
              >
                <el-option
                  v-for="item in jbrList"
                  :key="item.id"
                  :label="item.xm"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label="经办人身份证:"
              prop="jbrSfzh"
              :rules="validateNullLog"
            >
              <el-input
                v-model="form.jbrSfzh"
                disabled
                placeholder="请输入经办人身份证"
              />
            </el-form-item>
            <el-form-item
              label="经办人手机号:"
              prop="jbrSjh"
              :rules="validateNullLog"
            >
              <el-input
                v-model="form.jbrSjh"
                disabled
                placeholder="请输入经办人手机号码"
              />
            </el-form-item>
            <el-form-item
              label="备注:"
              prop="bz"
              :rules="{
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'xt', 500);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="form.bz"
                :disabled="tjhctype"
                placeholder="请输入"
              />
            </el-form-item>
          </div>
          <div class="imgtitle2">
            <img src="../../assets/img/dcdwxx.png" alt="">
          </div>
          <div class="secondbf">
            <el-form-item
              label="单位名称:"
              prop="tcdwMc"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 200);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="form.tcdwMc"
                :disabled="tjhctype"
                placeholder="请输入或选择单位名称"
              />

              <el-button
                v-preventReClick
                type="primary"
                style="background: #4170ff"
                :disabled="tjhctype"
                @click="selectdwmc()"
              >选择</el-button>
            </el-form-item>
            <el-form-item
              label="统一社会信用代码:"
              label-width="140px"
              prop="tcdwTyshxydm"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 100);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="form.tcdwTyshxydm"
                :disabled="tjhctype"
                placeholder="请输入"
              />
            </el-form-item>
            <el-form-item
              label="单位法人/经营者:"
              prop="tcdwDwfr"
              label-width="140px"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 200);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="form.tcdwDwfr"
                :disabled="tjhctype"
                placeholder="请输入单位法人/经营者"
              />
            </el-form-item>
            <el-form-item
              label="单位座机:"
              prop="tcdwDwzj"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 50);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="form.tcdwDwzj"
                :disabled="tjhctype"
                placeholder="请输入单位座机"
              />
            </el-form-item>
            <el-form-item
              label="单位地址:"
              prop="tcdwDwdz"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 600);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="form.tcdwDwdz"
                :disabled="tjhctype"
                placeholder="请输入单位地址"
              />
            </el-form-item>
            <el-form-item
              label="联系人姓名:"
              prop="tcdwLxrxm"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 200);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="form.tcdwLxrxm"
                :disabled="tjhctype"
                placeholder="请输入联系人姓名"
              />
            </el-form-item>
            <el-form-item
              label="联系人身份证:"
              prop="tcdwLxrsfzh"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 100);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="form.tcdwLxrsfzh"
                :disabled="tjhctype"
                placeholder="请输入联系人身份证"
              />
            </el-form-item>
            <el-form-item
              label="联系人手机号:"
              prop="tcdwLxrsjhm"
              :rules="{
                required: true,
                validator: (rule, value, callback) => {
                  lengthValidate(rule, value, callback, 'bt', 50);
                },
                trigger: ['blur', 'change'],
              }"
            >
              <el-input
                v-model="form.tcdwLxrsjhm"
                :disabled="tjhctype"
                placeholder="请输入联系人手机号"
              />
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="imgtitle3">
        <img src="@/assets/img/xgcl.png" alt="">
      </div>

      <div class="tishi">
        <img src="@/assets/img/tishi.png" alt="">
        <p>
          提示：“营业执照复印件”和“其他组织的登记证书或者成立批准文件复印件”二选一即可；支持上传png、jpg、bmp格式，500KB以内证件照片。
        </p>
      </div>
      <div class="thirdbf">
        <ul class="uploadzhengjian">
          <li v-for="(item, i) in imgListArray" :key="i">
            <img
              v-preventReClick
              :src="item.imageurl"
              alt=""
              @click="imageClick(item.name, item.zjlx)"
            >
            <p
              @click="exportMb"
              v-html="tjhctype && i == 0 ? item.tishi1 : item.tishi"
            />
          </li>
        </ul>
      </div>

      <div class="sqly">
        <div class="title" style="margin-bottom: 28px">
          <img src="../../assets/img/sqly.png" alt="" srcset="">
        </div>
        <el-input
          v-model="tjyy"
          resize="none"
          :autosize="{ minRows: 4, maxRows: 6 }"
          type="textarea"
          maxlength="200"
          :disabled="tjhctype"
          placeholder="请填写申请调剂原因"
        />
      </div>
      <!-- <div class="fourbf" v-show="leixing == 'hx'">
        <div class="imgtitle4">
          <img src="../../assets/img/gmsqzjhx.png" alt="" />
        </div>
        <el-input
          required
          type="textarea"
          :rows="6"
          resize="none"
          placeholder="请填写核销原因"
          maxlength="200"
          v-model="hxyy"
        ></el-input>
      </div> -->

      <div v-show="leixing == 'qxhx'" class="fourbf">
        <div class="imgtitle4">
          <img src="../../assets/img/gmsqzjhx.png" alt="">
        </div>
        <el-input
          v-model="qxhxyy"
          required
          type="textarea"
          :rows="6"
          resize="none"
          placeholder="请填写取消核销原因"
        />
      </div>

      <div class="footer">
        <template v-if="leixing == 'view'">
          <el-button
            v-preventReClick
            style="background: #4170ff; margin-top: 30px"
            type="primary"
            @click="submitForm('form', '')"
          >关闭</el-button>
        </template>
        <template
          v-if="leixing == 'copy' || leixing == 'sq' || leixing == 'edit'"
        >
          <el-button
            v-preventReClick
            style="background: #ebebeb; color: black; border: none"
            @click="submitForm('form', 'zsbc')"
          >暂时保存</el-button>
          <el-button
            v-preventReClick
            style="background: #4170ff"
            type="primary"
            @click="submitForm('form', 'tj')"
          >提交申请</el-button>
        </template>

        <template v-else-if="leixing == 'qxhx'">
          <el-button
            v-preventReClick
            style="background: #ebebeb; color: black; border: none"
            @click="submitForm('form', 'qx')"
          >关闭</el-button>
          <el-button
            v-preventReClick
            style="background: #4170ff"
            type="primary"
            @click="submitForm('form', 'qrqxhx')"
          >确认</el-button>
        </template>
      </div>

    </div>
    <tjhc-dialog-inside
      ref="dialoggmsqinside"
      :type="tjhctype"
      :inner-visible="innerVisible"
      :xianshi="name"
      :insidehxp="insidehxp"
      @dialog-inside="DialogInside"
      @dialog-inside1="DialogInside1"
    />
  </div>
</template>
<script>
import { addTJHC, updateTJHC, cancelWriteOffTJHC } from '@/assets/js/tjhc.js'

import { lengthValidate } from '@/assets/js/validate'
// 获取接口地址
import {
  gethxpJlgmz,
  getgmzDwMes,
  addgmzwldwMes,
  getkv,
  jbrMes,
  getgmzyyzzhqtzwMes,
  getgmzhfsyMes,
  getgmzwlDwrwMes
} from '@/assets/js/common.js'
import { getdwforhxpBm } from '@/assets/js/yssq.js'
import TjhcDialogInside from './tjhcDialogInside.vue'
import { validateNull, validateSljy } from '@/assets/js/validate.js'
export default {
  name: 'Gmsq',
  components: {
    TjhcDialogInside
  },
  props: {
    dialogFormVisible: {
      type: Boolean
    },
    tjhctype: {
      type: Boolean
    },
    leixing: {
      type: String
    }
  },
  data() {
    return {
      loadingdialog: false,
      dataobj: {},
      titlename: [],
      insidehxp: {
        hxpBm: '',
        hxpMc: '',
        hfsyDwmc: ''
      },
      name: '', // 确认内层弹窗的内容
      // 许可证图片
      imgListArray: [],
      imgzjlx: 0,
      zjlxs: [],
      innerVisible: false, // dialog是否显示
      qxhxyy: '',
      hxyy: '',
      form: {
        // zt: "00", // 字典yzd_xkz_zt   00草稿  11 审批中
        hxpBm: '', // 化学品"102"
        hxpMc: '', // 化学品"102"
        tjsl: '', // 购买数量
        tjslDw: '', // 购买数量单位 "2"
        dj: '', // 单价
        djDw: '', // 单价单位
        zj: '', // 总价
        zjDw: '', // 总价单位
        nxql: '', // 年需求量
        nxqlDw: '', // 年需求量单位
        yt: '', // 用途
        gxhth: '', // ""购销合同号
        yxcs: '1', // 有效次数
        jbrZj: '',
        jbrXm: '', // 经办人姓名
        jbrSfzh: '', // 经办人身份证
        jbrSjh: '', // 经办人手机号码
        bz: '', // 备注
        tcdwMc: '', // 单位名称
        tcdwTyshxydm: '', // 社会信用代码
        tcdwDwfr: '', // 销售单位法人/经营者姓名
        tcdwDwzj: '', // 销售单位单位座机
        tcdwDwdz: '', // 销售单位地址
        tcdwLxrxm: '', // 销售人员姓名
        tcdwLxrsfzh: '', // 销售人员身份证
        tcdwLxrsjhm: '', // 销售人员手机号码
        zt: '',
        sqdwZj: '',
        tcdwBzxx: ''
      },
      validateNullLog: {
        required: true,
        validator: validateNull,
        trigger: ['blur', 'change']
      },
      dwId: '',
      tjyy: '', // 调剂原因
      rules: {},
      options: [], // 化学品级联数据
      yzd_nsjsl_dw: [], // 单位信息
      yzd_zjzj: [], // 总价单价单位信息
      xkzGmFjxxList: [], // 许可证所有信息
      id: '', // 编辑需携带的id
      jbrList: [],
      dwtcvisable: true,
      hxpsdata: {},
      wldwxx: {},
      sqdwZj: '',
      yxcslist: ['1'],
      yxcsdisabled: true,
      xkzBh: ''
    }
  },

  watch: {
    form: {
      deep: true,
      handler(newVal, oldVal) {
        if (this.form.hxpBm) {
          this.getdwforhxp(this.form.hxpBm)
        }
        if (this.form.dj && this.form.tjsl) {
          this.form.zj = this.accMul(this.form.dj, this.form.tjsl)
        } else if (this.form.dj == 0 || this.form.tjsl == 0) this.form.zj = 0
      }
    }
  },
  created() {
    jbrMes().then((e) => {
      this.jbrList = e.data.data
    })

    // 化学品数量单位
    getkv('yzd_nsjsl_dw').then((e) => {
      this.yzd_nsjsl_dw = e.data.data
    })
    // 化学品数量单位根据化学品变化
    // 单价总价单位
    getkv('yzd_xkzdjdw').then((e) => {
      this.yzd_zjzj = e.data.data
    })
    // 获取化学品级联数据
    gethxpJlgmz().then((e) => {
      this.options = e.data.data
    })
    this.$nextTick(() => { })
    this.imgListArray = [
      {
        zjlx: '3',
        name: '合法使用需要证明',
        tishi:
          "<span style='color: red;'>*</span>合法使用需要证明<br/> <a style='color: #4170ff;cursor: pointer;'>下载模板</a>",
        tishi1: " <span style='color: red;'>*</span> 合法使用需要证明",
        imageurl: this.xkzGmFjxxList.map((item) => item.zjlx).includes('3')
          ? require('../../assets/img/gmsqhfsy.png')
          : require('../../assets/img/step44_down.png')
      },
      {
        zjlx: '1',
        name: '营业执照',
        tishi: '营业执照',
        imageurl: this.xkzGmFjxxList.map((item) => item.zjlx).includes('1')
          ? require('../../assets/img/gmsqyyzz_down.png')
          : require('../../assets/img/gmsqyyzz.png')
      },
      {
        zjlx: '2',
        tishi: '其他组织的登记证书或者成立<br/>批准文件',
        name: '其他组织的登记证书或者成立批准文件',
        imageurl: this.xkzGmFjxxList.map((item) => item.zjlx).includes('2')
          ? require('../../assets/img/gmsqdjzs_down.png')
          : require('../../assets/img/gmsqdjzs.png')
      },
      {
        zjlx: '4',
        name: '购买单位经办人身份证',
        tishi: "<span style='color: red;'>*</span>购买单位经办人身份证",
        imageurl: this.xkzGmFjxxList.map((item) => item.zjlx).includes('4')
          ? require('../../assets/img/gmsqgmdw_down.png')
          : require('../../assets/img/gmsqgmdw.png')
      },
      {
        zjlx: '7',
        name: '其他证件',
        tishi: ' 其他证件',
        imageurl: this.xkzGmFjxxList.map((item) => item.zjlx).includes('7')
          ? require('../../assets/img/step45.png')
          : require('../../assets/img/step45_down.png')
      }
    ]
  },

  mounted() {
    if (this.leixing == 'sq') {
      this.getgmzyyzzhqtzwMess() // 营业执照带出数据
    }
  },
  methods: {
    accMul(arg1, arg2) {
      let m = 0; const s1 = arg1.toString(); const s2 = arg2.toString()
      try { m += s1.split('.')[1].length } catch (e) { }
      try { m += s2.split('.')[1].length } catch (e) { }
      return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
    },
    lengthValidate,
    validateSljy,
    validateNull,
    // 合法使用证明下载模板
    exportMb(e) {
      if (e.target.innerText.toString() == '下载模板') {
        const link = document.createElement('a')
        link.href = process.env.VUE_APP_PUBLIC_PORT + '/hfsyxyzm.doc'
        link.download = '模板'
        link.click()
      }
    },

    // 营业执照信息
    async getgmzyyzzhqtzwMess() {
      var ret = await getgmzyyzzhqtzwMes()
      if (ret.data.data.zjlx == '2') {
        ret.data.data.qtzjZsmc = ret.data.data.yyzzMc
        ret.data.data.qtzjZsbh = ret.data.data.yyzzTyshxydm
      }
      this.xkzGmFjxxList.push(ret.data.data)
      this.imagelistChange() // 营业执照带出信息后图片改变
    },
    imagelistChange() {
      this.imgListArray = [
        {
          zjlx: '3',
          name: '合法使用需要证明',
          tishi:
            "<span style='color: red;'>*</span>合法使用需要证明<br/> <a style='color: #4170ff;cursor: pointer;'>下载模板</a>",
          tishi1: " <span style='color: red;'>*</span> 合法使用需要证明",
          imageurl: this.xkzGmFjxxList.some(
            (item) => item.zjlx == '3' && item.fjList
          )
            ? require('../../assets/img/gmsqhfsy.png')
            : require('../../assets/img/step44_down.png')
        },
        {
          zjlx: '1',
          name: '营业执照',
          tishi: '营业执照',
          imageurl: this.xkzGmFjxxList.map((item) => item.zjlx).includes('1')
            ? require('../../assets/img/gmsqyyzz_down.png')
            : require('../../assets/img/gmsqyyzz.png')
        },
        {
          zjlx: '2',
          tishi: '其他组织的登记证书或者成立<br/>批准文件',
          name: '其他组织的登记证书或者成立批准文件',
          imageurl: this.xkzGmFjxxList.map((item) => item.zjlx).includes('2')
            ? require('../../assets/img/gmsqdjzs_down.png')
            : require('../../assets/img/gmsqdjzs.png')
        },
        {
          zjlx: '4',
          name: '购买单位经办人身份证',
          tishi: "<span style='color: red;'>*</span>购买单位经办人身份证",
          imageurl: this.xkzGmFjxxList.map((item) => item.zjlx).includes('4')
            ? require('../../assets/img/gmsqgmdw_down.png')
            : require('../../assets/img/gmsqgmdw.png')
        },
        {
          zjlx: '7',
          name: '其他证件',
          tishi: ' 其他证件',
          imageurl: this.xkzGmFjxxList.map((item) => item.zjlx).includes('7')
            ? require('../../assets/img/step45.png')
            : require('../../assets/img/step45_down.png')
        }
      ]
      if (this.form.hxpBm) {
        if (this.form.hxpBm.slice(0, 1) == '1') {
          this.yxcsdisabled = true
        } else {
          this.yxcsdisabled = false
        }
      }
      // 购销合同空
      if (!this.form.gxhth) {
        this.imgListArray.filter((item, index) => {
          if (item.zjlx == '6') {
            this.imgListArray.splice(index, 1)
          }
        })
        var flag1 = this.xkzGmFjxxList.some((item, index, arr) => {
          return item.zjlx == '6'
        })

        flag1 == true
          ? this.xkzGmFjxxList.filter((item, index, arr) => {
            if (item.zjlx == '6') {
              this.xkzGmFjxxList.splice(index, 1)
            }
          })
          : ''
      } else {
        var flag = this.imgListArray.some((item, index) => {
          return item.zjlx == '6'
        })
        flag == true
          ? ''
          : this.imgListArray.splice(this.imgListArray.length - 1, 0, {
            zjlx: '6',
            tishi: "<span style='color: red;'>*</span>购销合同",
            name: '购销合同',
            imageurl: this.xkzGmFjxxList
              .map((item) => item.zjlx)
              .includes('6')
              ? require('../../assets/img/gmsqgxht_down.png')
              : require('../../assets/img/gmsqgxht.png')
          })
      }
    },
    back() {
      this.reset()
    },
    dwmcblur() {
      getgmzwlDwrwMes(this.form.tcdwMc).then((e) => {
        this.form.tcdwDwdz = e.data.data.dwdz
        this.form.tcdwTyshxydm = e.data.data.shtyxydm
        this.form.tcdwDwfr = e.data.data.frmc
        this.form.tcdwDwzj = e.data.data.dwzj
        this.dwtcvisable = false
        this.wldwxx = e.data.data
      })
    },
    dwchange(val) { },
    gmrktz() {
      if (this.xkzBh) {
        this.$router.push({
          name: 'Gmrk',
          params: { xkzBh: this.xkzBh }
        })
      } else this.$message.error('没有许可证编号')
    },
    // 化学品级联改变
    handleChange(value) {
      if (value == undefined) return
      this.form.hxpBm = value.slice(-1).toString()
      // this.xh(this.options, this.form.hxpBm);
      this.hxpsdata = this.$refs.hxps.getCheckedNodes()[0].data
      this.form.hxpMc = this.hxpsdata.label
      this.form.nxql = this.hxpsdata.other.nxql
      this.form.nxqlDw = this.hxpsdata.other.nxqldw
      this.form.yt = this.hxpsdata.other.yt
      this.form.tjslDw = ''

      // 化学品编码改变时，购销合同中数据清空+
      var flag1 = this.xkzGmFjxxList.some((item, index, arr) => {
        return item.zjlx == '6'
      })

      flag1 == true
        ? this.xkzGmFjxxList.filter((item, index, arr) => {
          if (item.zjlx == '6') {
            this.xkzGmFjxxList.splice(index, 1)
          }
        })
        : ''
      // 合法使用情空
      var flag2 = this.xkzGmFjxxList.some((item, index, arr) => {
        return item.zjlx == '3'
      })

      flag2 == true
        ? this.xkzGmFjxxList.filter((item, index, arr) => {
          if (item.zjlx == '3') {
            this.xkzGmFjxxList.splice(index, 1)
          }
        })
        : ''
      // 申请带出合法使用证件初始化信息
      // if (this.leixing == "sq" && this.form.hxpBm) {
      this.getgmzhfsyMess(this.form.hxpBm) // 根据化学品编码带出合法使用数据
      // }
      this.imagelistChange()
    },
    // 添加往来单位名称
    addDW() {
      this.$confirm('是否将该单位加入往来单位？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        distinguishCancelAndClose: true,
        center: true,
        message: '是否将该单位加入往来单位？'
      })
        .then(() => {
          // 添加往来单位信息
          addgmzwldwMes({
            id: '', // 没有值为新增，有值为修改
            dwId: '',
            glrwdwId: this.wldwxx.glrwdwId,
            dwmc: this.form.tcdwMc,
            shtyxydm: this.form.tcdwTyshxydm,
            dwdz: this.form.tcdwDwdz,
            frmc: this.form.tcdwDwfr,
            dwzj: this.form.tcdwDwzj,
            dwsj: this.wldwxx.dwsj,
            dwxz: this.wldwxx.dwxz,
            dwlx: this.wldwxx.dwlx
          }).then((e) => {
            this.$message.success('添加成功!')
            this.$refs['form'].resetFields()
            this.$emit('close-dialog')
            this.$parent.search() // 关闭
          })
        })
        .catch(() => {
          this.$message.info('已取消')
          this.$refs['form'].resetFields()
          this.$emit('close-dialog')
          this.$parent.search() // 关闭
        })
    },
    // 选择单位打开弹窗
    selectdwmc() {
      this.innerVisible = true
      this.name = '单位'
    },
    // 根据往来单位带出信息
    getgmzDwMess(data) {
      getgmzDwMes(data).then((e) => {
        this.form.tcdwMc = e.data.data.dwmc
        this.form.tcdwTyshxydm = e.data.data.shtyxydm
        this.form.tcdwDwfr = e.data.data.frmc
        this.form.tcdwDwzj = e.data.data.dwzj
        this.form.tcdwDwdz = e.data.data.dwdz
        // this.dwtcvisable = true;
      })
    },
    getsphjMess(dataobj) {
      for (var key of Object.keys(dataobj)) {
        dataobj[key].forEach((hj, index) => {
          if (key == 'zssq') {
            if (index == 0) {
              this.titlename.push({
                keyname: key,
                ImageUrl: require('@/assets/img/bgsp/crksqsp.png')
              })
            }
            if (index == dataobj.zssq.length - 1 || dataobj.zssq.length == 1) {
              hj.icon = 'el-icon-success'
              hj.size = 'large'
            }
          } else {
            dataobj[key + index] = []
            hj.forEach((qxhxhj, index1) => {
              if (index1 == hj.length - 1 || hj.length == 1) {
                qxhxhj.icon = 'el-icon-success'
                qxhxhj.size = 'large'
              }
              if (index1 == 0) {
                this.titlename.push({
                  keyname: key + index,
                  ImageUrl: require('@/assets/img/bgsp/qxhxsp.png')
                })
              }
              dataobj[key + index].push(qxhxhj)
            })
          }
        })
      }
      delete dataobj.zsqxhx
      this.dataobj = dataobj
    },
    // 初始化表单内容
    getformMes(dataMes) {
      console.log('xxx---===', dataMes)
      this.id = this.leixing == 'copy' ? '' : dataMes.id // 根据id来知道编辑的数据
      this.xkzBh = dataMes.xkzBh
      this.sqdwZj = dataMes.sqdwZj
      // 申请调剂原因
      this.tjyy = dataMes.tjyy
      this.dwId = dataMes.dwId
      this.form = Object.assign(
        {},
        {
          zt: dataMes.zt,
          hxpMc: dataMes.hxpMc,
          hxpBm: dataMes.hxpBm, // 化学品
          // tjsl: this.leixing == "view" ? dataMes.hzsl : dataMes.tjsl, //购买数量
          // tjslDw: this.leixing == "view" ? dataMes.hzslDw : dataMes.tjslDw, //购买数量单位
          tjsl: dataMes.tjsl, // 购买数量
          tjslDw: dataMes.tjslDw, // 购买数量单位
          dj: dataMes.dj, // 单价
          djDw: dataMes.djDw, // 单价单位
          zj: dataMes.zj, // 总价
          zjDw: dataMes.zjDw, // 总价单位
          nxql: dataMes.nxql, // 年需求量
          nxqlDw: dataMes.nxqlDw, // 年需求量单位
          yt: dataMes.yt, // 用途
          gxhth: dataMes.gxhth, // ""购销合同号
          yxcs: this.leixing == 'view' ? dataMes.hzcs : dataMes.yxcs, // 有效次数
          jbrZj:
            this.leixing == 'view' || this.leixing == 'qxhx'
              ? dataMes.jbrXm
              : dataMes.jbrZj,
          jbrXm: dataMes.jbrXm, // 经办人姓名
          jbrSfzh: dataMes.jbrSfzh, // 经办人身份证
          jbrSjh: dataMes.jbrSjh, // 经办人手机号码
          bz: dataMes.bz, // 备注

          tcdwMc: dataMes.tcdwMc, // 单位名称
          tcdwTyshxydm: dataMes.tcdwTyshxydm, // 社会信用代码
          tcdwDwfr: dataMes.tcdwDwfr, // 销售单位法人/经营者姓名
          tcdwDwzj: dataMes.tcdwDwzj, // 销售单位单位座机
          tcdwDwdz: dataMes.tcdwDwdz, // 销售单位地址
          tcdwLxrxm: dataMes.tcdwLxrxm, // 销售人员姓名
          tcdwLxrsfzh: dataMes.tcdwLxrsfzh, // 销售人员身份证
          tcdwLxrsjhm: dataMes.tcdwLxrsjhm, // 销售人员手机号码
          tcdwBzxx: dataMes.tcdwBzxx
        }
      )
      this.xkzGmFjxxList = dataMes.xkzGmFjxxList // 附件信息
      console.log(...this.xkzGmFjxxList, 'csh')
      if (this.leixing == 'copy' && this.xkzGmFjxxList.length > 0) {
        this.xkzGmFjxxList.forEach((item, index) => {
          if (item.fjList.length > 0) {
            item.id = ''
            item.fjList.forEach((item) => {
              item.id = ''
            })
          }
        })
      }

      this.yxcslist =
        this.form.yxcs != '' && this.form.yxcs != null
          ? this.form.yxcs.split(',')
          : this.form.hxpBm.slice(0, 1) == '1'
            ? ['1']
            : ['2']

      this.$nextTick(() => {
        this.imagelistChange()
      })
    },
    // 根据化学品获取单位信息
    async getdwforhxp(bm) {
      var ret = await getdwforhxpBm(bm)
      this.yzd_nsjsl_dw = ret.data.data
      return ret.data.data
    },
    // 保存表单添加和修改的数据
    saveHandle(dataObj) {
      let API = addTJHC
      if (dataObj.id) {
        API = updateTJHC
      }
      API(dataObj)
        .then((e) => {
          this.$message.success('提交成功!')
          this.loadingdialog = false
          this.reset()
        })
        .catch(() => {
          this.loadingdialog = false
        })
    },
    djDwChange(val) {
      this.form.zjDw = val
    },
    // 经办人
    jbrChange(val) {
      this.jbrList.some((item) => {
        if (item.id == val) {
          this.form.jbrXm = item.xm
          this.form.jbrSfzh = item.zjhm.trim()
          this.form.jbrSjh = item.sjhm
          var flag = this.xkzGmFjxxList.some((item, index, arr) => {
            return item.zjlx == '4'
          })
          if (flag) {
            var arr = this.xkzGmFjxxList.filter((item2, index, arr) => {
              return item2.zjlx == '4'
            })
            var id = arr[0].id
          }

          flag == true
            ? this.xkzGmFjxxList.filter((item1, index, arr) => {
              if (item1.zjlx == '4') {
                this.xkzGmFjxxList.splice(index, 1, {
                  id: id,
                  zjlx: '4',
                  gmdwjbrXm: item.xm,
                  gmdwjbrjbrSjh: item.sjhm,
                  gmdwjbrjbrSfzh: item.zjhm,
                  fjList: [{ wjdz: item.zjzpZm, zjlx: '4', id: '' }]
                })
              }
            })
            : item.zjzpZm
              ? this.xkzGmFjxxList.push({
                zjlx: '4',
                gmdwjbrXm: item.xm,
                gmdwjbrjbrSjh: item.sjhm,
                gmdwjbrjbrSfzh: item.zjhm,
                fjList: [{ wjdz: item.zjzpZm, zjlx: '4', id: '' }]
              })
              : ''
        }
      })
      this.imagelistChange()
    },
    yxcschange(value) {
      if (value.slice(-1) != '') {
        this.yxcslist = []
        this.form.yxcs = value.slice(-1).toString()
        this.yxcslist.push(value.slice(-1).toString())
      } else this.yxcslist.push(this.form.yxcs)
    },
    // 清空所有数据
    reset() {
      this.id = ''
      this.xkzGmFjxxList = []
      // 点确认按钮后往来单位信息
      // if (!this.dwtcvisable && this.tjhctype != true) {
      //   this.addDW();
      // } else {
      this.$refs['form'].resetFields()
      this.$emit('close-dialog')
      // this.$nextTick(() => {
      // this.$parent.search(); //关闭
      // });
      // }
    },
    // 提交表单内容
    submitForm(formName, type) {
      console.log(this.form)
      // type:tj zsbc
      // 如果是不可编辑，不需要验证
      if (this.tjhctype == true) {
        if (this.leixing == 'qxhx' && type == 'qrqxhx') {
          if (this.qxhxyy == '' || this.qxhxyy.length == 0) {
            this.$message.error('请填写原因')
            return false
          } else {
            this.$confirm('确认取消核销吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(() => {
              this.loadingdialog = true
              console.log('--===-----==--', this.dwId)
              cancelWriteOffTJHC({
                id: this.id,
                qxhxly: this.qxhxyy,
                dwId: this.dwId
              })
                .then((e) => {
                  this.$message.success('取消核销成功!')
                  this.loadingdialog = false
                  this.reset()
                })
                .catch(() => {
                  this.loadingdialog = false
                })
            })
          }
        } else this.reset()
        return
      }
      // 许可证必传三个中的两个
      var zjlxs = []
      var mes = []

      // 编辑和复制新增需要验证
      this.$refs[formName].validate((valid, obj) => {
        if (!valid) {
          setTimeout(() => {
            var isError = document.getElementsByClassName('is-error')
            isError[0].querySelector('input').focus()
          }, 100)
          return false
        } else {
          if (this.xkzGmFjxxList.length > 0) {
            this.xkzGmFjxxList.forEach((item, index) => {
              if (item.fjList) {
                item.zjlx && item.fjList.length > 0
                  ? zjlxs.push(parseInt(item.zjlx))
                  : ''
              }
            })
          }

          console.log(...this.xkzGmFjxxList, 'tj')
          if (zjlxs.includes(3)) {
          } else mes.push('合法使用证件')
          if (zjlxs.includes(1) || zjlxs.includes(2)) {
          } else mes.push('营业执照 或 其他组织的登记证书或者成立')
          if (zjlxs.includes(4)) {
          } else mes.push('购买单位经办人身份证')
          if (this.imgListArray.map((item) => item.zjlx).includes('6')) {
            // 如果包含购销合同数据
            if (zjlxs.includes(6)) {
            } else {
              mes.push('购销合同')
            }
          }
        }
        if (valid && mes.length == 0) {
          this.xkzGmFjxxList = this.xkzGmFjxxList.filter((item, index) => {
            return item.fjList && item.zjlx && item.fjList.length > 0
          })
          this.zt = type == 'zsbc' ? '00' : '11'
          var data = {
            sqdwZj: this.sqdwZj,
            id: this.id,
            dwId: this.dwId,
            hxpMc: this.form.hxpMc || '',
            hxpBm: this.form.hxpBm || '', // 化学品
            tjsl: this.form.tjsl || '', // 购买数量
            tjslDw: this.form.tjslDw || '', // 购买数量单位
            dj: this.form.dj || 0, // 单价
            djDw: this.form.djDw || '', // 单价单位
            zj: this.form.zj || 0, // 总价
            zjDw: this.form.zjDw || '', // 总价单位
            nxql: this.form.nxql || '', // 年需求量
            nxqlDw: this.form.nxqlDw || '', // 年需求量单位
            yt: this.form.yt || '', // 用途
            gxhth: this.form.gxhth || '', // ""购销合同号
            yxcs: this.form.yxcs || '', // 有效次数
            jbrZj: this.form.jbrZj || '',
            jbrXm: this.form.jbrXm || '', // 经办人姓名
            jbrSfzh: this.form.jbrSfzh || '', // 经办人身份证
            jbrSjh: this.form.jbrSjh || '', // 经办人手机号码
            bz: this.form.bz || '', // 备注
            tcdwMc: this.form.tcdwMc || '', // 单位名称
            tcdwTyshxydm: this.form.tcdwTyshxydm || '', // 社会信用代码
            tcdwDwfr: this.form.tcdwDwfr || '', // 销售单位法人/经营者姓名
            tcdwDwzj: this.form.tcdwDwzj || '', // 销售单位单位座机
            tcdwDwdz: this.form.tcdwDwdz || '', // 销售单位地址
            tcdwLxrxm: this.form.tcdwLxrxm || '', // 销售人员姓名
            tcdwLxrsfzh: this.form.tcdwLxrsfzh || '', // 销售人员身份证
            tcdwLxrsjhm: this.form.tcdwLxrsjhm || '', // 销售人员手机号码
            xkzGmFjxxList: this.xkzGmFjxxList,
            zt: this.zt,
            tjyy: this.tjyy,
            tcdwBzxx: this.form.tcdwBzxx
          }

          if (type == 'tj') {
            this.$confirm('此操作将不可撤回, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(() => {
              this.loadingdialog = true
              this.saveHandle(data) // 提交
            })
          } else if (type == 'zsbc') {
            this.$confirm('此操作将暂时保存为草稿, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: true
            }).then(() => {
              this.loadingdialog = true
              this.saveHandle(data) // 提交
            })
          } else {
            this.reset()
          }
        } else {
          mes.length == 0
            ? ''
            : this.$message({
              type: 'error',
              message: '请补全' + mes.toString() + '信息'
            })
          return false
        }
      })
    },
    // 许可证弹窗
    imageClick(name, zjlx) {
      this.name = name
      this.innerVisible = true
      // 筛选出证件类型符合的数据
      var arr = this.xkzGmFjxxList.filter((item, index, arr) => {
        return item.zjlx == zjlx
      })
      // 购销合同化学品和外部化学品保持一致
      if (zjlx == '6') this.insidehxp.hxpBm = this.form.hxpBm

      console.log(arr[0])
      if (!arr[0]) {
        arr[0] = {}
        arr[0].fjList = []
      }
      this.$refs.dialoggmsqinside.cshYm(arr[0], zjlx)
    },

    // 合法使用信息
    async getgmzhfsyMess(data) {
      var flag = this.xkzGmFjxxList.some((item, index, arr) => {
        return parseInt(item.zjlx) == 3
      })
      var ret = await getgmzhfsyMes(data)
      flag == true
        ? this.xkzGmFjxxList.filter((item1, index, arr) => {
          if (parseInt(item1.zjlx) == 3) {
            this.xkzGmFjxxList.splice(index, 1, ret.data.data)
          }
        })
        : this.xkzGmFjxxList.push(ret.data.data)
      this.imagelistChange()
    },
    // 许可证变化 //有了购销合同号才有购销合同
    gxhthImage(val) {
      this.imgListArray.filter((item, index) => {
        if (item.zjlx == '6') {
          this.imgListArray.splice(index, 1)
        }
      })
      var flag1 = this.xkzGmFjxxList.some((item, index, arr) => {
        return item.zjlx == '6'
      })

      flag1 == true
        ? this.xkzGmFjxxList.filter((item, index, arr) => {
          if (item.zjlx == '6') {
            this.xkzGmFjxxList.splice(index, 1)
          }
        })
        : ''
      this.imagelistChange()
    },

    // 关闭许可证弹窗
    DialogInside(val) {
      this.innerVisible = false

      if (!this.tjhctype && val != undefined) {
        // this.xkzGmFjxxList含有这个证件类型de信息和图片
        var flag = this.xkzGmFjxxList.some((item, index, arr) => {
          return parseInt(item.zjlx) == parseInt(val.zjlx)
        })

        flag
          ? this.xkzGmFjxxList.filter((item, index, arr) => {
            if (parseInt(item.zjlx) == parseInt(val.zjlx)) {
              this.xkzGmFjxxList.splice(index, 1, val)
            }
          })
          : val.fjList.length > 0
            ? this.xkzGmFjxxList.push(val)
            : ''

        // console.log(this.xkzGmFjxxList, "add");
        this.imagelistChange()
      }
    },
    dwmcFocus() {
      this.dwtcvisable = false
    },
    // 关闭单位弹窗
    DialogInside1(val) {
      this.innerVisible = false
      if (this.name == '单位' && val != '') {
        // 得到选择的单位信息
        this.getgmzDwMess(val) // 根据往来单位带出信息
      }
    }
  }
}
</script>
<style lang="less" scoped>
.gmsqDialog {
  width: 95%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
  background-color: #fff;

  .imgtitle1,
  .imgtitle2,
  .imgtitle3 {
    padding: 40px 117px;
    img {
      height: 22px;
    }
  }
  .imgtitle1 {
    img {
      width: 145px;
    }
  }
  .imgtitle2 {
    img {
      width: 127px;
    }
  }
  .imgtitle3 {
    border-top: 10px solid #eef1f9;
    padding: 40px 117px 28px 117px;
    img {
      width: 91px;
    }
  }

  .formmes {
    /deep/ .el-form {
      .firstbf,
      .secondbf {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 0 117px 40px;
        border-bottom: 10px solid #eef1f9;

        .el-form-item {
          margin-right: 0px;
          margin-bottom: 20px;
          height: 39px;
          width: 47% !important;
          // .el-form-item__label {
          //   text-align: left;
          // }
          .el-form-item__content {
            display: flex;
          }
        }
        .el-col-16,
        .el-col-8 {
          .el-form-item {
            width: 100% !important;
          }
        }
      }
      .firstbf {
        .el-form-item {
          &:nth-child(1),
          &:nth-child(3),
          &:nth-child(5),
          &:nth-child(7),
          &:nth-child(9),
          &:nth-child(12) {
            .el-form-item__label {
              width: 103px;
            }
          }
          &:nth-child(2),
          &:nth-child(4),
          &:nth-child(6),
          &:nth-child(8) {
            .el-form-item__label {
              width: 88px;
            }
          }

          &:nth-child(1),
          &:nth-child(6),
          &:nth-child(7),
          &:nth-child(8) {
            .el-form-item__content {
              .el-select {
                width: 100% !important;
              }
              .el-cascader {
                width: 100% !important;
              }
            }
          }
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5) {
            .el-form-item__content {
              & > .el-input {
                margin-right: 10px;
              }
            }
          }
          &:nth-child(9),
          &:nth-child(10),
          &:nth-child(11) {
            width: 30% !important;
          }
          &:nth-child(12) {
            width: 100% !important;
            .el-form-item__content {
            }
          }
        }
      }
      .secondbf {
        .el-form-item {
          &:nth-child(1),
          &:nth-child(3),
          &:nth-child(5),
          &:nth-child(7) {
            .el-form-item__label {
              width: 118px;
            }
          }
          &:nth-child(2),
          &:nth-child(4),
          &:nth-child(6),
          &:nth-child(8) {
            .el-form-item__label {
              width: 135px;
            }
          }
          &:nth-child(2) {
            .el-form-item__label {
              width: 138px;
            }
          }
          &:nth-child(1) {
            .el-form-item__content {
              // width: 340px;
              .el-input {
                // width: 268px;
              }
              .el-button--primary {
                // width: 65px;
                margin-left: 7px;
              }
            }
          }

          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4),
          &:nth-child(5),
          &:nth-child(6),
          &:nth-child(7),
          &:nth-child(8) {
            .el-form-item__content {
              // width: 340px;
            }
            .el-select {
              width: 100% !important;
            }
          }
        }
      }
    }
  }
  .tishi {
    padding: 0 117px 31px;

    img {
      width: 15px;
      height: 15px;
      margin-right: 5px;
      vertical-align: middle;
    }
    p {
      display: inline-block;
      height: 18px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #636363;
      line-height: 18px;
    }
  }
  .thirdbf {
    padding: 0 117px;
    padding-bottom: 50px;
    .uploadzhengjian {
      display: flex;
      flex-wrap: wrap;
      padding: 0;
      margin: 0;
      text-align: center;

      li {
        width: 202px;
        margin-right: 50px;
        list-style: none;
        &:nth-child(4n) {
          margin-right: 0;
        }
        img {
          width: 202px;
          height: 138px;
        }
        p {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 18px;
          a {
            cursor: pointer;
          }
        }
      }
    }
  }
  .sqly {
    border-top: 10px solid #eef1f9;
    background-color: white;
    padding: 40px 118px;
    margin-bottom: 15px;
    .buttonList {
      text-align: center;
    }
  }
  .fourbf {
    border-top: 10px solid #eef1f9;
    padding: 40px 117px 0;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #aeaeae;
    line-height: 21px;
      .imgtitle4 {
      margin-bottom: 30px;
      img {
        width: 127px;
        height: 22px;
      }
    }
    .el-textarea__inner:focus {
      outline: 0;
      border-color: #dcdfe6;
    }
  }
  .footer {
    padding: 70px 0 47px;
    text-align: center;
    .el-button {
      width: 148px;
      height: 60px;
      margin: 0 95px;
    }
  }
}
/deep/ .el-message-box {
  width: 518px !important;
  height: 270px;
}
</style>
